<div class="notes-modal" *transloco="let t; prefix: 'parts.modals'">
  <!-- Header -->
  <div class="notes-header">
    <h5 class="notes-title">{{ title }}</h5>
  </div>

  <!-- Content -->
  <div class="notes-body">
    <!-- Add note textarea -->
    @if (showAddNote) {
      <span class="notes-label">{{ t('fields.note') }}</span>
      <textarea
        #noteInput
        class="note-input"
        [placeholder]="t('placeholders.addNotes')"
        [formControl]="noteControl"
        rows="3">
      </textarea>
    }

    <!-- Existing notes -->
    @if (isLoading) {
      <div class="notes-state">
        <div class="spinner-border spinner-border-sm" role="status"></div>
      </div>
    } @else if (hasError) {
      <div class="notes-state">
        <i class="ph ph-warning-circle notes-state__icon"></i>
        <span class="notes-state__text">{{ t('viewNotes.loadFailed') }}</span>
      </div>
    } @else {
      @if (regularNotes.length > 0) {
        @if (!showAddNote) {
          <span class="notes-label">{{ t('fields.note') }}</span>
        }
        <div class="notes-list">
          @for (note of regularNotes; track $index) {
            <div class="note-card">
              <p class="note-card__content">{{ displayContent(note.content, 'r' + $index) }}</p>
              @if (isLong(note.content)) {
                <button type="button" class="note-card__toggle" (click)="toggleExpand('r' + $index)">
                  {{ isExpanded('r' + $index) ? t('viewNotes.readLess') : t('viewNotes.readMore') }}
                </button>
              }
              <span class="note-card__meta">• {{ note.createdBy }} - {{ note.createdAt | date: 'dd MMM yy HH:mm' }}</span>
            </div>
          }
        </div>
      }

      @if (rejectionNotes.length > 0) {
        <span class="notes-label">{{ t('viewNotes.rejectionNotes') }}</span>
        <div class="notes-list">
          @for (note of rejectionNotes; track $index) {
            <div class="note-card">
              <p class="note-card__content">{{ displayContent(note.content, 'j' + $index) }}</p>
              @if (isLong(note.content)) {
                <button type="button" class="note-card__toggle" (click)="toggleExpand('j' + $index)">
                  {{ isExpanded('j' + $index) ? t('viewNotes.readLess') : t('viewNotes.readMore') }}
                </button>
              }
              <span class="note-card__meta">• {{ note.createdBy }} - {{ note.createdAt | date: 'dd MMM yy HH:mm' }}</span>
            </div>
          }
        </div>
      }
    }
  </div>

  <!-- Footer -->
  <div class="notes-footer">
    <button type="button" class="btn-close-notes" (click)="onClose()">{{ 'common.close' | transloco }}</button>
    @if (showAddNote) {
      <button type="button" class="btn-save-notes" [disabled]="isSaving" (click)="onSave()">
        @if (isSaving) {
          <span class="spinner-border spinner-border-sm"></span>
        } @else {
          {{ t('actions.save') }}
        }
      </button>
    } @else {
      <button type="button" class="btn-add-new" (click)="onAddNote()">{{ t('viewNotes.addNew') }}</button>
    }
  </div>
</div>